/* eslint-disable unicorn/filename-case */
/* eslint-disable camelcase */

import { ILanguageData } from "../props";

export const esES: ILanguageData = {
  welcome_login: "Bienvenido a iniciar sesión",
  account: "Numero de Cuenta",
  password: "Contraseña",
  remember_pwd: "Recordar la contraseña",
  login: "Iniciar sesión",
  login_account_required: "Se requiere nombre de usuario",
  login_pwd_required: "Se requiere contraseña",
  input_keyword_search: "Por favor, introduzca la búsqueda de palabras clave",
  learning_data: "Aprende los datos",
  my_course: "Mi curso",
  my_exam: "Mi examen",
  more_courses: "Más cursos",
  exam_review: "Evaluación del examen",
  departmental_course: "Tutorial departamental",
  update_tutorial: "Actualización del tutorial",
  all: "Todo",
  pending_participation_exam: "Pendiente",
  pending_review_exam: "Pendiente de revisión",
  not_passed_exam: "No aprobado",
  passed_exam: "Ha pasado",
  course_number: "Número del curso",
  course_title: "Nombre del curso",
  exam_time: "Tiempo de examen",
  exam_duration: "Duración del examen",
  quiz_creator: "Persona que elabora las preguntas",
  total_question_number: "Número total de preguntas",
  exam_number: "Número de examen",
  remaining_exam_attempts: "Número de exámenes restantes",
  times: "veces",
  check_score: "Ver resultados",
  start_exam: "Comenzar examen",
  compulsory_course: "Obligatorio",
  elective_course: "Optativo",
  duration: "Duración",
  course: "Cursos",
  featured: "Tutoriales",
  pcs: "Piezas",
  minutes: "Minutos",
  data_learned: "Ha estudiado",
  to_learn: "A estudiar",
  learned: "Ha estudiado",
  learning: "En el estudio",
  history: "Registro histórico",
  learning_dueation: "Tiempo de estudio",
  lecturer: "Instructor",
  exam_start_time: "Hora de inicio del examen",
  exam_end_time: "Hora de finalización del examen",
  // score: "Puntuación: {{score}} Puntos",
  score_one: "Puntuación: {{score}} Punto",
  score_other: "Puntuación: {{score}} Puntos",
  view_details: "Ver detalles",
  copy_link: "Copiar enlace",
  failed_grade: "Reprobado",
  passed_grade: "Aprobado",
  single_choice: "Elecciones individuales",
  multiple_choice: "Selección múltiple",
  judgment: "Juicio",
  fill_blank: "Rellenar los espacios en blanco",
  // total_score: "Puntuación total: {{totalScore}} Puntos",
  total_score_one: "Puntuación total: {{totalScore}} Punto",
  total_score_other: "Puntuación total: {{totalScore}} Puntos",
  // questions_total: "Total de {{questionCount}} preguntas",
  questions_total_other: "Total de {{questionCount}} preguntas",
  questions_total_one: "Total de {{questionCount}} pregunta",
  exam_submission_time: "Tiempo de envío del examen",
  exam_paper_number: "Número de examen",
  number_of_associated_course: "Número de curso asociado",
  exam_marker: "Revisor",
  number_of_questions_to_be_reviewed: "Número de preguntas por revisar",
  review_status: "Estado de la evaluación",
  operation: "Operación",
  to_be_reviewed: "Pendiente de revisión",
  reviewed: "Revisado", // 未确定
  distributed: "Distribuido", // 未确定
  review: "Revisión",
  department: "Departamento",
  position: "Puestos",
  nameOfViewer: "Nombre del espectador",
  organizationOfTheViewer: "Organización a la que pertenece el espectador",
  viewingStatus: " Estado de visualización",
  viewingTime: "Tiempo de visualización",
  question_and_answer: "Preguntas y respuestas",
  i_posted: "Lo publiqué.",
  name: "Nombre",
  description: "Descripción",
  personnel_scope: "Alcance del personal",
  shelf_time: "Tiempo en los estantes",
  courseware_upload: "Material didáctico",
  click_or_drag: "Haga clic o arrastre archivos aquí para subir",
  courseware_stage_has_exam:
    "Hay un examen en la etapa donde se encuentra el material didáctico",
  extension_support: "Extensiones soportadas",
  cancel: "Cancelar",
  confirm: "Confirmar",
  organizational_structure: "Estructura organizativa",
  selected_person: "Personal seleccionado",
  message_center: "Centro de mensajes",
  message_list: "Lista de mensajes",
  unread_message: "Mensajes no leídos",
  read_message: "Mensajes leídos",
  on_the_shelf: "En proceso de publicación",
  removed_from_shelves: "Fuera de línea",
  no_related_content: "Lo sentimos, no se encontraron contenido relacionado",
  unwatched: "Sin ver",
  watching: "Viendo",
  watched: "Visto",
  viewing_record: "Ver registro",
  my_viewing_record: "Mi historial de visualizaciones",
  delete: "Eliminar",
  modify: "Modificar",
  publisher: "Editor",
  viewing_time: "Tiempo de visualización",
  name_of_viewer: "Nombre del espectador",
  organization_of_the_viewer: "Organización a la que pertenece el espectador",
  viewing_status: "Estado de visualización",
  tutorial_staff_watches_the_record: "Los tutores ven los registros",
  course_introduction: "Introducción al curso",
  more: "Más",
  course_evaluation: "Evaluación curricular",
  correctAnswerMessage: "¡Felicidades, respuesta correcta!",
  wrongAnswer: "Lamentablemente, respuesta incorrecta.",
  yourAnswer: "Tu respuesta: {{yourAnswer}}",
  correctAnswer: "Respuesta correcta: {{correctAnswer}}",
  answerAnalysis: "Análisis de respuestas: {{answerAnalysis}}",
  comment: "Comentario:{{comment}}",
  mark: "Calificación: {{score}} Puntos",
  remainingTime: "Tiempo restante: ",
  submit: "Enviar",
  submit_failed: "Falló el envío, ¡intente de nuevo!",
  submit_success: "¡Envío exitoso!",
  viewing_history: "Ver registros históricos",
  courseware_name: "Nombre del material didáctico",
  courseware_number: "Número del material didáctico",
  dept_course: "Tutorial departamental",
  dept_tutorials_number: "Número del tutorial departamental",
  my_dept_tutorials: "Mis tutoriales del departamento estudiados",
  course_description: "Descripción del curso",
  tutorial_publish: "Publicación del tutorial",
  tutorial_description: "Introducción al tutorial",
  copy: "Copiar",
  copy_success: "Copiado con éxito",
  copy_failed: "Fallo al copiar",
  i_learned: "Mis estudios",
  multiplier: "Doble velocidad",
  clarity: "Claridad",
  whether_to_delete_data: "¿Eliminar datos?",
  whether_to_give_up_save: "¿Confirmar abandonar la edición?",
  yes: "Sí",
  no: "No",
  file_type_not_supported: "Solo se admiten formatos MP4, MOV, JPG, PNG, PDF",
  student_count: "Número total de estudiantes",
  course_instructor: "Instructor del curso",
  learning_progress: "Progreso del aprendizaje",
  my_pending_courses: "Mis cursos pendientes",
  dept_course_number: "Número de curso del departamento",
  join_course: "¿Participar en el curso?",
  course_expired:
    "El curso ha excedido el tiempo de estudio disponible y no puede continuar.",
  no_tutorials: "No hay tutoriales disponibles",
  upload_type_tips:
    "Solo se pueden subir archivos del mismo tipo, y solo se puede subir uno de MP4 y PDF",
  examination_title: "Nombre del examen",
  paper_number: "Número de examen",
  submitter: "Persona que envía",
  submission_time: "Tiempo de envío",
  distribution_success: "Puntuaciones distribuidas con éxito",
  distribute: "Distribuir", // 不確定
  attachment: "Adjunto",
  confirm_exit_exam: "¿Salir del examen?",
  clear_unread: "Marcar todo como leído",
  scan_qr_code:
    "Por favor, escanee el código QR arriba para llenar la evaluación del curso",
  distribution_select_results:
    "Por favor, seleccione las puntuaciones a distribuir",
  pending_examination: "Exámenes pendientes de aprobación",
  test_paper_submission_time: "Tiempo de envío del examen",
  answer: "Respuesta",
  review_score: "Calificación",
  points: "Puntos",
  review_remark: "Comentario",
  review_remark_empty: "Los comentarios no pueden estar vacíos",
  review_points_empty: "La puntuación no puede estar vacía",
  tutorials: "Tutorial",
  tutorials_number: "Número del tutorial",
  logout: "Salir",
  version: "Versión",
  empty_exams: "No hay exámenes todavía",
  empty_course: "No hay cursos todavía",
  empty_score: "No hay resultados todavía",
  empty_content: "No hay contenido aún",
  clear: "Vacíe",
  echo_avatar: "Echo Avatar",
  translation_video: "Traducir video",
  start_make: "开始制作",
  sure_make: "确认制作",
  cancel_making: "关闭",
  cancel_make: "取消制作",
  language: "语种",
  tone: "Tono de voz",
  make_state: "Estado de producción",
  speech_draft: "讲稿",
  download: "Descargar",
  download_failed_open_tab: "Error al descargar, por favor descargue manualmente en una nueva pestaña",
  try_listen: "Escucha de prueba",
  template_download: "模版下载",
  output_language_speech_color_selection: "输出语种语音色选择",
  original_language: "Idioma original",
  translation_language: "转译语种",
  video_duration: "视频时长",
  video_name: "视频名称",
  ea_note:
    "Nota: Si necesita clonar el tono de voz, hágalo en el cliente Echo Avatar (inicie sesión con la misma cuenta).",
  ea_tooltip:
    "讲稿可自行选择是否导入；如不导入，系统将对视频中的音频进行人工智能识别，智能生成讲稿；如导入，系统将按照讲稿内容进行多语种版本制作。",
  total_video_duration: "视频总时长",
  original: "Texto original",
  translation: "Texto traducido",
  word_count: "字数",
  back: "Regresar",
  sure: "确定",
  preview: "Vista previa",
  batch_download: "Descarga por lotes",
  multilingual_translation: "多语言转译",
  ea_hash: "Hash",
  making: "制作中",
  please_select_the_original_language:
    "Por favor, seleccione el idioma original",
  please_select_the_target_language: "Por favor, seleccione el idioma objetivo",
  please_select_language: "Seleccione language",
  please_select_a_tone: "Por favor, seleccione el tono de voz",
  whether_to_cancel_production: "是否取消制作",
  search_history: "Historial de búsqueda",
  target_language: "Idioma objetivo",
  create_translation_video: "Crear proyecto de video traducido",
  advanced_option: "Opciones avanzadas",
  subtitles: "Subtítulo",
  video_advanced_option: {
    option1:
      "Conservar los sonidos de fondo（Conservar sonidos de fondo no humanos, como música y ruido）",
    option2:
      "Traducción directa（Omitir la verificación de texto y generar directamente el video）",
    option3: "Subtítulos（Generar subtítulos en el idioma objetivo）",
  },
  original_language_and_target_language_conflict:
    "原始语言不能与目标语言相同，请重新选择",
  save: "Guardar",
  translate: "Traducir video",
  ai_analysis: "Análisis de IA",
  regular_duration: "Tiempo normal",
  recommended_duration: "Tiempo recomendado",
  ai_rewrite: "Reescritura de IA",
  slow_speech_rate_tip: {
    option1: "Voz lenta",
    option2:
      "El texto traducido es más corto que el texto original. Recomendamos agregar caracteres para mantener el ritmo natural del habla.",
  },
  fast_speech_rate_tip: {
    option1: "Voz rápida",
    option2:
      "El texto traducido es más largo que el texto original. Recomendamos reducir caracteres para mantener el ritmo natural del habla.",
  },
  subtitle_time_range_is_incorrect: {
    option1:
      "El tiempo de inicio no puede ser posterior al tiempo de finalización",
    option2:
      "El tiempo de finalización no puede ser posterior al tiempo de inicio de la siguiente oración",
  },
  video_time_format: "El formato de hora es HH:mm:ss,mmm",
  making_tips: "Generando {{progress}}%",
  no_data: "No hay datos disponibles",
  index_page: "Inicio",
  share: "Compartir",
  playing_failed: "No jugar",
  intelligent_creation: {
    intelligent_creation: "Creación inteligente",
    dual_podcast: "Doble podcast",
    single_person_talk: "Monólogo de una persona",
    background_image: "Imagen de fondo",
    creation_type: "Tipo de creación",
    audio: "Audio",
    video: "Videofrecuencia",
    upload_text: "Haga clic para cargar",
    upload_tip: "Solo se admiten archivos .pdf, y el tamaño máximo es de 10mb",
    podcard_content_tip:
      "Por favor, ingrese el contenido del podcast o cargue un archivo PDF",
    ai_creation: "Creación con IA",
    use_my_script: "Usar mi guion",
    podcast_content_input_placeholder_ai:
      "Ingrese temas, ideas o cargue materiales de referencia para que la IA genere automáticamente un guion completo de podcast con un solo clic.",
    podcast_content_input_placeholder_custom:
      "Ingrese un guion existente, y el sistema lo convertirá automáticamente en un guion de podcast correspondiente.",
    script_format_requirement:
      'Format tips:\n·Se requieren saltos de línea para distinguir los diálogos entre "Presentador" e "intervencionista".\n·Los roles de diálogo están limitados a "Presentador" e "intervencionista".',
    script_format_example:
      "[Ejemplo de formato]\nPresentador: Hola a todos...\nintervencionista: Sí, nosotros...\nPresentador: Entonces...\nintervencionista: De hecho, en realidad...",
    script_format_error:
      "El script no cumple con los requisitos de formato. Por favor, edite y vuelva a intentarlo.",
    input_script_placeholder: "Por favor, ingrese el guion",
    apply_script: "Aplicar guion",
    mandarin: "El mandarín",
    cantonese: "chino cantonés",
    compere: "Presentador",
    interview_guest: "Entrevistar a invitados",
    my_tone: "Mi timbre",
    digital_image_and_timbre: "Imagen digital y timbre",
    my_customization: "Mi personalización",
    system_tone: "Timbre del sistema",
    podcast_content: "Contenido del podcast",
    system_presets: "Sistema preestablecido",
    custom: "La costumbre",
    customize: "Personalizar para personalizar",
    tone_genere_tip: "Generando timbre, espera {{minutes}} minutos",
    generate_script: "Generar un script",
    no_content: "Por favor, complete la configuración primero～",
    generate_audio: "Generar audio",
    generate_video: "Generar video",
    audio_balance: "Saldo de audio(Hora: minuto: segundo)",
    video_balance: "Saldo de video(Hora: minuto: segundo)",
    audio_generate_tip:
      "Nota: debido a las características de generación de ia, puede haber cierta desviación en la duración final de audio y video. La deducción de la cuota se ejecutará en la duración real.",
    too_long_script_tip:
      "El script en general es demasiado largo para cumplir con la configuración de duración. Vuelva a editarlo o deje que la ia le ayude a modificarlo a través de las instrucciones.",
    too_short_script_tip:
      "El script en general es demasiado corto para cumplir con la configuración de duración. Vuelva a editarlo o deje que la ia le ayude a modificarlo a través de las instrucciones.",
    tone_customization: "Personalización de timbre",
    upload_file_tip1:
      "El archivo es demasiado grande, por favor, vuelva a cargarlo",
    upload_file_tip2:
      "La duración no cumple con los requisitos. Por favor, vuelva a subir",
    whether_to_confirm_deletion: "¿Está seguro de que desea eliminar?",
    whether_to_confirm_submission: "¿Se confirma el envío?",
    material_text: "Texto del material",
    material_text_tip:
      "El texto es generado por reconocimiento de IA. Si difiere del material original, puedes editarlo para mejorar la precisión del clonado de voz.",
    material_language: "Idioma del material",
    tone_name: "Nombre de timbre",
    reference_audio: "Audio de referencia",
    upload_audio_tip:
      'Por favor, suba un audio de voz personal claro (el idioma debe coincidir con el "idioma de continuación", sin ruido de fondo y solo con una persona hablando).',
    upload_audio_tip2: "Formato: MP3, Tamaño máximo: 150MB",
    generating: "generando",
    script_generating: "generando script",
    script_generat_failed:
      "generación de script fallida, por favor, vuelva a intentarlo",
    basic_setting_changed_tip:
      "Ajustes han cambiado, por favor, vuelva a generar el script!",
    delete_tone_tip1:
      "El audio seleccionado no puede ser eliminado, por favor, ajuste y vuelva a intentarlo",
    delete_tone_tip2: "El audio está siendo generado, no se puede eliminar",
    generate_failed_tip:
      "Generación de audio fallida, por favor, vuelva a intentarlo",
    queuing_tip: "En línea, espere unos minutos",
    queuing_tip1:
      "En línea, se espera que la generación comience en {{minutes}} minutos",
    submit_tip: "（No se puede modificar de nuevo después de enviar）",
    draft_tip: "Recordatorio",
    draft_tip1:
      "Existe una tarea de generación en cola/generada/completada. ¿Quieres continuar?",
    draft_tip2: "（después de la renuncia no se hará ningún ahorro）",
    back_tip1: "¿Se confirma la devolución?",
    back_tip2:
      "(si hay una tarea de generación en cola/generación en proceso/terminada, se puede ver de nuevo la próxima vez que ingrese, si no, no se guarda)",
    background_sound_error_tip:
      "Se nota ruido de fondo; por favor, vuelve a subirlo.",
    invalid_voice_error_tip:
      "No se ha detectado ninguna voz humana válida. Vuelva a cargar el archivo.",
    multiple_voices_error_tip:
      "Se han detectado varias voces. Vuelva a cargar el archivo.",
    audio_check_failed_error_tip:
      "Detección fallida. Vuelva a cargar el archivo.",
    no_pdf_file_error_tip: "No es un archivo PDF. Vuelva a cargar el archivo.",
    checking: "Comprobando",
    host: "presentador",
    guest: "intervencionista",
    digital_image: "imagen digital",
    digital_image_group: "grupo de imagen digital",
    add_digital_image_group: "añadir grupo de imagen digital",
    my_digital_images: "mis imágenes digitales",
    no_digital_image_tip:
      "No hay opciones todavía. Por favor, complete la personalización primero!",
    ai_generate: "Generar con IA",
    over_word_limit_tip:
      "Se ha alcanzado el límite máximo de palabras. No se puede ingresar si se excede el límite.",
    upload_photo: "Subir foto",
    upload_photo_tip1:
      "Por favor, suba una foto personal (solo, frontal, asegúrese de que la cara no esté bloqueada) para generar una imagen digital",
    upload_photo_tip2: "Formato: png/jpg tamaño: dentro de 10MB",
    under_inspection: "Bajo detección",
    digital_image_customization: "Personalización de imagen digital",
    least_one_dialogue_box_tip: "Debe haber un diálogo mínimo",
    detect_faild_tip:
      "El servicio está saturado; inténtalo de nuevo más tarde.",
    no_full_face_image_tip:
      "Por favor, sube una foto completa de cara positiva",
    no_single_person_image_tip:
      "Solo se admiten fotos individuales. Por favor, vuelva a subir",
    contains_illegal_content_tip:
      "Contiene contenido ofensivo. Por favor, vuelva a subir",
    clarity_low_tip: "Claro demasiado bajo. Por favor, vuelva a subir",
    no_original_image_tip: "Por favor, cargue directamente la imagen original",
    simple_chinese: "Chino simplificado",
    traditional_chinese: "Chino tradicional",
    over_limit_tip:
      "{{name}} están por encima del límite actual disponible. Si desea agregar algo, primero elimine el exceso.",
    personal_tone: "personal tone",
    personal_digital_image: "personal digital image",
    personal_digital_image_tip:
      "Por favor, añada primero una combinación de imágenes digitales",
    personal_tone_tip: "El campo Tono no puede quedar vacío",
    no_generation_result: "Sin resultados de generación aún",
    digital_human_footage: "Imagen de digital humano",
    add_digital_human_footage: "Añadir imagen de digital humano",
    digital_human_footage_tip: "Por favor, añada primero una imagen de digital humano",
    creation_content: "Contenido de creación",
  },
  input_placeholder: "Escriba aquí",
  no_permissions: "No tiene permisos",
  add: "Añadir",
  delete_success: "Eliminado con éxito",
  route_error: "¡Ruta no válida!",
};
